import { render, staticRenderFns } from "./ReportTrainerSalary.vue?vue&type=template&id=8bfbd7b6&"
import script from "./ReportTrainerSalary.vue?vue&type=script&lang=js&"
export * from "./ReportTrainerSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports